import { Badge, List, ListItemText, ListItemSecondaryAction, ListItemButton } from '@mui/material';
import { OrderQueues } from 'helpers/enums';
import { applicationContext } from 'helpers/services';
import { useContext } from 'react';
import { ordersContext } from '../OrdersContext';


let Queues = () => {
    let { referenceData } = useContext(applicationContext);
    let { search, orderQueuesCount, changeQueue } = useContext(ordersContext);

    return (
        <List
            style={{ position: 'sticky', top: 72 }}
            component="nav"
        >
            {referenceData.OrderQueues.map(queue =>
                <ListItemButton
                    key={queue.key}
                    selected={search.queue === queue.key}
                    onClick={() => changeQueue(queue.key)}
                >
                    <ListItemText
                        primary={queue.value}
                        secondary={queue.key === OrderQueues.Closed || queue.key === OrderQueues.Cancelled ? 'Last 90 days' : undefined}
                    />
                    {queue.key !== OrderQueues.AllOrders && queue.key !== OrderQueues.Dashboard &&
                        <ListItemSecondaryAction>
                            <Badge
                                max={99999}
                                color="primary"
                                overlap="rectangular"
                                badgeContent={orderQueuesCount.getValueByKey(queue.key)?.toString()}
                            />
                        </ListItemSecondaryAction>
                    }
                </ListItemButton>
            )}
        </List>
    )
}

export default Queues;